import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=5b923d2f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=5b923d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b923d2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b923d2f')) {
      api.createRecord('5b923d2f', component.options)
    } else {
      api.reload('5b923d2f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=5b923d2f&scoped=true&", function () {
      api.rerender('5b923d2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O8L2ShFSGyBz/JS/teamMember.vue"
export default component.exports